var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2773V33.9172C0 36.4818 2.08641 38.5683 4.65105 38.5683H7.36667V23.835H6.03417C3.44145 23.835 1.17901 22.397 0 20.2773Z",
    fill: "url(#paint0_linear_620_1335)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2334 23.834H12.1334V38.5673H8.2334V23.834Z",
    fill: "url(#paint1_linear_620_1335)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.967 4.76797C36.6838 4.76797 37.267 4.18479 37.267 3.46797C37.267 2.75115 36.6838 2.16797 35.967 2.16797C35.2502 2.16797 34.667 2.75115 34.667 3.46797C34.667 4.18479 35.2502 4.76797 35.967 4.76797Z",
    fill: "url(#paint2_linear_620_1335)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3995 26.8673C23.3995 27.1067 23.2056 27.3007 22.9662 27.3007H22.0995V28.1673C22.0995 29.601 20.9332 30.7673 19.4995 30.7673C18.0659 30.7673 16.8995 29.601 16.8995 28.1673V27.3007H16.0328C15.7935 27.3007 15.5995 27.1067 15.5995 26.8673V23.834H12.9995V38.5673H25.9995V23.834H23.3995V26.8673Z",
    fill: "url(#paint3_linear_620_1335)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33294 4.76745C5.2887 4.76745 6.06628 3.98987 6.06628 3.03411C6.06628 2.07835 5.2887 1.30078 4.33294 1.30078C3.37718 1.30078 2.59961 2.07835 2.59961 3.03411C2.59961 3.98987 3.37718 4.76745 4.33294 4.76745Z",
    fill: "url(#paint4_linear_620_1335)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.3005V16.933C0 20.2603 2.70686 22.9672 6.03417 22.9672H7.8H12.5667H16.0333H22.9667H26.4333H31.2H32.9658C36.2931 22.9672 39 20.2603 39 16.933V14.3005V13.8672H0V14.3005Z",
    fill: "url(#paint5_linear_620_1335)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 9.10091H28.1667V7.67091C28.1667 6.07 26.8642 4.76758 25.2633 4.76758H14.17C12.5691 4.76758 11.2667 6.07 11.2667 7.67091V9.10091H2.6C1.16636 9.10091 0 10.2673 0 11.7009V13.0009H39V11.7009C39 10.2673 37.8336 9.10091 36.4 9.10091ZM12.1333 7.67091C12.1333 6.54788 13.047 5.63424 14.17 5.63424H25.2633C26.3864 5.63424 27.3 6.54788 27.3 7.67091V9.10091H12.1333V7.67091Z",
    fill: "url(#paint6_linear_620_1335)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9658 23.835H31.6333V38.5683H34.3488C36.9135 38.5683 39 36.4818 39 33.9172V20.2773C37.821 22.397 35.5585 23.835 32.9658 23.835Z",
    fill: "url(#paint7_linear_620_1335)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.533 26.434V23.834H16.4663V26.434H17.333H21.6663H22.533Z",
    fill: "url(#paint8_linear_620_1335)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8667 23.834H30.7667V38.5673H26.8667V23.834Z",
    fill: "url(#paint9_linear_620_1335)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5004 29.9008C20.4562 29.9008 21.2338 29.1232 21.2338 28.1674V27.3008H17.7671V28.1674C17.7671 29.1232 18.5447 29.9008 19.5004 29.9008Z",
    fill: "url(#paint10_linear_620_1335)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6827 2.60078C30.0417 2.60078 30.3327 2.30977 30.3327 1.95078C30.3327 1.5918 30.0417 1.30078 29.6827 1.30078C29.3237 1.30078 29.0327 1.5918 29.0327 1.95078C29.0327 2.30977 29.3237 2.60078 29.6827 2.60078Z",
    fill: "url(#paint11_linear_620_1335)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1495 6.93477C33.5085 6.93477 33.7995 6.64375 33.7995 6.28477C33.7995 5.92578 33.5085 5.63477 33.1495 5.63477C32.7905 5.63477 32.4995 5.92578 32.4995 6.28477C32.4995 6.64375 32.7905 6.93477 33.1495 6.93477Z",
    fill: "url(#paint12_linear_620_1335)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6832 1.3C17.0422 1.3 17.3332 1.00899 17.3332 0.65C17.3332 0.291015 17.0422 0 16.6832 0C16.3242 0 16.0332 0.291015 16.0332 0.65C16.0332 1.00899 16.3242 1.3 16.6832 1.3Z",
    fill: "url(#paint13_linear_620_1335)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74961 5.20039C10.1086 5.20039 10.3996 4.90938 10.3996 4.55039C10.3996 4.19141 10.1086 3.90039 9.74961 3.90039C9.39062 3.90039 9.09961 4.19141 9.09961 4.55039C9.09961 4.90938 9.39062 5.20039 9.74961 5.20039Z",
    fill: "url(#paint14_linear_620_1335)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.65 6.93477C1.00899 6.93477 1.3 6.64375 1.3 6.28477C1.3 5.92578 1.00899 5.63477 0.65 5.63477C0.291015 5.63477 0 5.92578 0 6.28477C0 6.64375 0.291015 6.93477 0.65 6.93477Z",
    fill: "url(#paint15_linear_620_1335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_620_1335",
    x1: 3.68333,
    y1: 20.2773,
    x2: 3.68333,
    y2: 38.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_620_1335",
    x1: 10.1834,
    y1: 23.834,
    x2: 10.1834,
    y2: 38.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_620_1335",
    x1: 35.967,
    y1: 2.16797,
    x2: 35.967,
    y2: 4.76797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_620_1335",
    x1: 19.4995,
    y1: 23.834,
    x2: 19.4995,
    y2: 38.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_620_1335",
    x1: 4.33294,
    y1: 1.30078,
    x2: 4.33294,
    y2: 4.76745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_620_1335",
    x1: 19.5,
    y1: 13.8672,
    x2: 19.5,
    y2: 22.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_620_1335",
    x1: 19.5,
    y1: 4.76758,
    x2: 19.5,
    y2: 13.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_620_1335",
    x1: 35.3166,
    y1: 20.2773,
    x2: 35.3166,
    y2: 38.5683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_620_1335",
    x1: 19.4996,
    y1: 23.834,
    x2: 19.4996,
    y2: 26.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_620_1335",
    x1: 28.8167,
    y1: 23.834,
    x2: 28.8167,
    y2: 38.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_620_1335",
    x1: 19.5004,
    y1: 27.3008,
    x2: 19.5004,
    y2: 29.9008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_620_1335",
    x1: 29.6827,
    y1: 1.30078,
    x2: 29.6827,
    y2: 2.60078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_620_1335",
    x1: 33.1495,
    y1: 5.63477,
    x2: 33.1495,
    y2: 6.93477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_620_1335",
    x1: 16.6832,
    y1: 0,
    x2: 16.6832,
    y2: 1.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_620_1335",
    x1: 9.74961,
    y1: 3.90039,
    x2: 9.74961,
    y2: 5.20039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_620_1335",
    x1: 0.65,
    y1: 5.63477,
    x2: 0.65,
    y2: 6.93477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F037E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9AFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveJobs);
export default __webpack_public_path__ + "static/media/activeJobs.33af75f72410878543dc1bda2ce5095d.svg";
export { ForwardRef as ReactComponent };